<app-page-shell variant="default">
<div class="card card-box mb-5">
      <div class="card-header py-3">
        <div class="card-header--title font-size-lg">
          Manage Registration Platforms
        </div>
        <div class="card-header--actions">
          <a class="btn btn-sm btn-primary" [routerLink]="['add']" sbEntityLink role="button">
            <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
            <span class="btn-wrapper--label">Add New Platform</span>
          </a>
        </div>
      </div>
      <div class="p-3">
        <app-sb-table
          [rows]="registrationPlatformList()"
          [totalRows]="totalPlatforms()"
          [columns]="tableColumns"
          [options]="tableOptions"
          (stateChange)="onTableState($event)">

          <div class="d-flex flex-wrap" sbTableFilterExtra>
            <div class="client-dropdown">
              <app-creatable-select
                [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false"
                [placeholder]="'Widget Integration Guide'" [selectOptions]="supportTypes" valueKey="value"
                (optionSelected)="onSupportSelect($event, 'widget_integration_guide')"></app-creatable-select>
            </div>

            <div class="client-dropdown">
              <app-creatable-select
                [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false"
                [placeholder]="'Widget Custom Code'" [selectOptions]="supportTypes" valueKey="value"
                (optionSelected)="onSupportSelect($event, 'widget_customization_code')"></app-creatable-select>
            </div>

            <div class="client-dropdown">
              <app-creatable-select
                [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false"
                [placeholder]="'Widget Custom CSS'" [selectOptions]="supportTypes" valueKey="value"
                (optionSelected)="onSupportSelect($event, 'widget_customization_css')"></app-creatable-select>
            </div>
            <div class="client-dropdown">
              <app-creatable-select
                [selectedValue]="widgetFilterValues"
                [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false"
                [placeholder]="'Select Widget Support Values'" [selectOptions]="widgetSupportValues" valueKey="value"
                (optionSelected)="onWidgetValuesSelect($event)"></app-creatable-select>
            </div>
            <div class="client-dropdown">
              <app-creatable-select
                [selectedValue]="syncFilterValues"
                [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false"
                [placeholder]="'Select Sync Support Values'" [selectOptions]="syncSupportValues" valueKey="value"
                (optionSelected)="onSyncValuesSelect($event)"></app-creatable-select>
            </div>
          </div>

          <ng-template sbTableHeader="integration_projects">
            <span title="Projects using the platform for sync: an active integration row on the project">Sync projects</span>
          </ng-template>

          <ng-template sbTableCell="image" let-platform>
            @if (platform.image) {
            <img class="image-thumbnail" [src]="platform.image" alt=""/>
            }
          </ng-template>
          <ng-template sbTableCell="name" let-platform><span class="fw-bold">{{platform.name}}</span></ng-template>
          <ng-template sbTableCell="website" let-platform>
            <div class="widget_code"><a href="{{platform.website}}" target="_blank">{{platform.website}}</a></div>
          </ng-template>
          <ng-template sbTableCell="widget_projects" let-platform>
            <div class="widget-projects">
              @for (project of platform.widget_projects; track project; let last = $last) {
              <span class="project-list">
                <span class="cursor-pointer" (click)="navigateAssociates(project.id)">{{project.title}}</span>
                @if (!last) {
                <span> | </span>
                }
              </span>
              }
            </div>
          </ng-template>
          <ng-template sbTableCell="integration_projects" let-platform>
            <div class="integration-projects">
              @for (project of platform.integration_projects; track project; let last = $last) {
              <span class="project-list">
                <span class="cursor-pointer" (click)="navigateAssociates(project.id)">{{project.title}}</span>
                @if (!last) {
                <span> | </span>
                }
              </span>
              }
            </div>
          </ng-template>
          <ng-template sbTableCell="widget_integration_guide" let-platform>
            <div class="widget_code">{{platform.widget_integration_guide?.length ? 'Yes' : ''}}</div>
          </ng-template>
          <ng-template sbTableCell="widget_customization_code" let-platform>{{platform.widget_customization_code?.length ? 'Yes' : ''}}</ng-template>
          <ng-template sbTableCell="widget_customization_css" let-platform>{{platform.widget_customization_css?.length ? 'Yes' : ''}}</ng-template>

          <ng-template sbTableActions let-platform>
            <button class="btn-icon float-end" mat-icon-button [matMenuTriggerFor]="menu"
                    aria-label="Example icon-button with a menu">
              <span class="fa fa-ellipsis-v"></span>
            </button>
            <mat-menu #menu="matMenu" class="campaign-popover">
              <a class="dropdown-item" [routerLink]="['edit', platform.id]" sbEntityLink>
                <i class="fa fa-pencil me-2"></i>Edit</a>
              <a class="dropdown-item" (click)="deleteRegistrationPlatform(platform.id)">
                <i class="fa fa-trash me-2"></i>Delete</a>
            </mat-menu>
          </ng-template>
        </app-sb-table>
      </div>
    </div>
</app-page-shell>
